/**
 * Resolve the signed-in user label for report history (`X-Requested-By`).
 * Prefers a display name, then email / username from localStorage auth payload.
 */
export function resolveRequestedByName(): string | null {
  try {
    const raw =
      localStorage.getItem('user') ||
      localStorage.getItem('currentUser') ||
      localStorage.getItem('userData');
    if (raw) {
      const user = JSON.parse(raw) as Record<string, unknown>;
      const first =
        (typeof user['custom:first_name'] === 'string' && user['custom:first_name']) ||
        (typeof user.given_name === 'string' && user.given_name) ||
        (typeof user.firstName === 'string' && user.firstName) ||
        '';
      const last =
        (typeof user['custom:last_name'] === 'string' && user['custom:last_name']) ||
        (typeof user.family_name === 'string' && user.family_name) ||
        (typeof user.lastName === 'string' && user.lastName) ||
        '';
      const display = `${first} ${last}`.trim();
      if (display) return display.slice(0, 255);

      const single =
        (typeof user.name === 'string' && user.name) ||
        (typeof user.displayName === 'string' && user.displayName) ||
        (typeof user.username === 'string' && user.username) ||
        (typeof user.email === 'string' && user.email) ||
        (typeof user.Email === 'string' && user.Email) ||
        '';
      if (single.trim()) return single.trim().slice(0, 255);
    }

    const direct =
      localStorage.getItem('username') || localStorage.getItem('userName');
    if (direct?.trim()) return direct.trim().slice(0, 255);
  } catch {
    /* ignore */
  }

  try {
    const token = localStorage.getItem('ap_idToken');
    if (token) {
      const payload = JSON.parse(
        atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))
      ) as Record<string, unknown>;
      const email = typeof payload.email === 'string' ? payload.email.trim() : '';
      if (email) return email.slice(0, 255);
      const preferred =
        typeof payload.preferred_username === 'string'
          ? payload.preferred_username.trim()
          : '';
      if (preferred) return preferred.slice(0, 255);
    }
  } catch {
    /* ignore */
  }

  return null;
}
